<template>
    <div v-bind:class="['result-body',colorClass]">
        <div v-if="childrenBody !== null">
            <div class="headers">
                <div v-if="childrenBody.request_headers.trim() !== ''">
                    <h3>Req Headers</h3>
                    <pre v-highlightjs="childrenBody.request_headers.trim()"><code class="http"></code></pre>
                </div>
                <div v-if="childrenBody.response_headers.trim() !== ''">
                    <h3>Resp Headers</h3>
                    <pre v-highlightjs="childrenBody.response_headers.trim()"><code class="http"></code></pre>
                </div>
            </div>
            <template v-if="childrenBody.content.trim() !== ''">
                <h3><a v-bind:class="{'rotated':bodyExpanded}" href="#" v-on:click="bodyExpanded = !bodyExpanded"><chevron-right-icon></chevron-right-icon></a>Body</h3>
                <div v-show="bodyExpanded" class="body">
                    <pre v-highlightjs="childrenBody.content.trim()"><code class="html"></code></pre>
                </div>
            </template>
            <div v-if="childrenBody.error != null">
                <h3>Error Description</h3>
                <pre v-highlightjs="childrenBody.error.trim()"><code class="http"></code></pre>
            </div>
        </div>
        <div v-else class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
</template>
<script>
    import axios from 'axios'
    import config from '@/config'

    import CopyLink from "@/components/UI/_base-UI-CopyLink";

    import { ChevronRightIcon} from 'vue-feather-icons'

    export default {
        name: "URLResultBody",
        components:{
            CopyLink,
            ChevronRightIcon
        },
        data: function () {
            return {
                childrenBody: null,
                bodyExpanded: false
            }
        },
        mounted:function(){
            this.getChildrenBody()
        },
        props: {
            id: String,
            colorClass: String
        },
        methods: {
            getChildrenBody: function (){
                axios
                    .get(config.api_url + '/?op=urlresults&cmd=get_heavy&id='+this.id)
                    .then(response => {
                        this.childrenBody = response.data;
                    })
            }
        }
    }
</script>
<style scoped>
    .body{
        overflow: auto;
        max-width: 100%;
        max-height: 30rem;
        padding: 0.5rem;
        color: #ffffff;
        background-color: #000000;
        background-image: repeating-linear-gradient(45deg, transparent, transparent 15px, rgba(255,255,255,.5) 15px, rgba(255,255,255,.5) 30px);
    }

    .body code{
        font-family: monospace;
    }

    .rotated {
        animation: deg90 300ms ease 0s 1;
        animation-fill-mode: forwards;
    }

    pre{
        font-family: monospace;
    }

    div.result-body, div{
        width: -webkit-fill-available;
        padding: 0;
    }

    .result-body{
        border-left: 3px solid #ffffff;
        border-right: 3px solid #ababab;
        border-top: 1px solid #5a5a5a;
        border-bottom: 2px solid #ffffff;
    }

    .result-body.green{
        border-right-color: #39a35e;
    }

    .result-body.green .headers {
        border-top: 1px solid #368d4b;
    }

    .result-body h3{
        margin: 0.2rem 0.5rem;
        color: #ffffff;
        text-shadow: -1px 1px 0px #5b5b5b;
    }

    .result-body h3 a{
        display: inline-block;
        text-decoration: underline;
    }

    .result-body h3 svg{
        vertical-align: middle;
        height: 1.3rem;
    }

    .headers{
        display: flex;
        flex-direction: row;
    }

    .headers div{
        flex: 1 50%;
        padding: 0.5rem;
        overflow: auto;
    }

    .lds-ellipsis.small {
        width: 28px;
        height: 28px;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }

    .lds-ellipsis.small div {
        top: 8px;
        border-radius: 50%;
        background: #93291E;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #93291E;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

    .slideup, .slidedown {
        max-height: 0;
        overflow-y: hidden;
        -webkit-transition: max-height 0.5s ease-in-out;
        -moz-transition: max-height 0.5s ease-in-out;
        -o-transition: max-height 0.5s ease-in-out;
        transition: max-height 0.5s ease-in-out, padding-top 0.5s ease-in-out, padding-bottom 0.5s ease-in-out;
        align-items: start;
    }

    div.slideup{
    }

    div.slidedown {
        max-height: 30rem;
    }
</style>
